"use strict";
var urls = require('common/urls');
var hlp = require('common/helpers');
var controller = function($scope, $rootScope, $http, $filter, $uibModal, permissions) {
  $scope.urls = urls;
  $scope.config = {
    itemsPerPage: 50,
    maxPages: 50,
    paginatorLabels: {
      stepBack: '‹',
      stepAhead: '›',
      jumpBack: '«',
      jumpAhead: '»',
      first: 'Erste',
      last: 'Letzte'
    }
  };
  $scope.getList = function() {
    $scope.loading = true;
    var params = {
      "archivnr": $scope.archivnr,
      "query": $scope.query,
      "queryStatus": $scope.queryStatus,
      "max_pages": $scope.config.maxPages,
      "per_page": $scope.config.itemsPerPage
    };
    $http.get('api/registration.json', {params: params}).success(function(data, status, headers, config) {
      if (data.registrations)
        $scope.registrations = data.registrations;
      else
        $scope.registrations = [];
      $scope.countReturned = data.countReturned;
      $scope.countAvailable = data.countAvailable;
    }).catch(function(data, status, headers, config) {}).finally(function() {
      $scope.loading = false;
      saveFilter(params);
      $scope.orderBy($scope.activeCol);
    });
  };
  $scope.displayMultiple = function(values) {
    if (typeof values === 'undefined') {
      return '';
    }
    return values.join(', ');
  };
  $scope.refresh = function() {
    $scope.getList();
  };
  $scope.resetFilter = function() {
    localStorage.removeItem("registration-filter");
    initFilterDefaults();
    $scope.getList();
  };
  $scope.openDeleteModal = function(registration) {
    var modalInstance = $uibModal.open({
      templateUrl: 'registration/templates/deleteModal.ng.html',
      controller: ['$scope', '$uibModalInstance', 'params', function($scope, $uibModalInstance, params) {
        $scope.delete = function() {
          $http.delete('/api/registration/' + $scope.id + '.json', {params: {}}).success(function(data, status, headers, config) {
            $scope.response = data;
          }).catch(function(data, status, headers, config) {}).finally(function() {
            window.location = '/registration';
          });
        };
        var init = function() {
          $scope.id = params.id;
          $scope.registration = params.registration;
        }();
      }],
      resolve: {params: function() {
          return {
            id: registration._id.$oid,
            registration: registration
          };
        }}
    });
  };
  $scope.hasPermission = hlp.hasPermission;
  $scope.activeCol = 'bildthema';
  $scope.orderBy = function(name) {
    if ($scope.activeCol == name) {
      if ($scope.sortReverse == false) {
        $scope.sortReverse = true;
      } else {
        $scope.sortReverse = false;
      }
    }
    $scope.registrations = orderBy($scope.registrations, name, $scope.sortReverse);
    $scope.activeCol = name;
  };
  var orderBy = function(list, name, reverse) {
    return $filter('orderBy')(list, [name], reverse);
  };
  var saveFilter = function(params) {
    localStorage.setItem("registration-filter", JSON.stringify(params));
  };
  var initFilterDefaults = function() {
    $scope.query = "";
    $scope.archivnr = "";
    $scope.queryStatus = "";
  };
  var initFilter = function() {
    var filter = localStorage.getItem("registration-filter");
    if (filter != null) {
      var params = JSON.parse(filter);
      $scope.archivnr = params.archivnr;
      $scope.config.itemsPerPage = params.per_page;
      $scope.query = params.query;
      $scope.queryStatus = params.queryStatus;
      if (params.max_pages > 0)
        $scope.config.maxPages = params.max_pages;
    }
  };
  var init = function() {
    $scope.registrations = [];
    $scope.countReturned = 0;
    $scope.countAvailable = 0;
    $scope.permissions = permissions;
    initFilterDefaults();
    initFilter();
    $scope.getList();
  }();
};
module.exports = controller;
